/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTheme } from "@mui/material/styles";
import WebpageDialogButton from "components/webpage-selector/add-webpage-button/dialog-button";

const AddWebpageButton = (props) => {
    
    const theme = useTheme();
    const setOpen = props.setOpen;

    return (
        <Fragment>
            <WebpageDialogButton
                setOpen={setOpen}
                color={theme.palette.primary.main}
            />
        </Fragment>
    );
};

export { AddWebpageButton };
